import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Button from 'components/Button';

import css from './HMSSlide.module.scss';

class HMSSlide extends React.Component{
    static propTypes = {
        heading: PropTypes.string,
        description: PropTypes.string,
        illustration: PropTypes.string,
        illustrationAltText: PropTypes.string,
        readMore: PropTypes.string,
        readMoreText: PropTypes.string
    }

    render(){
        const {
            heading,
            description,
            illustration,
            illustrationAltText,
            readMore,
            readMoreText
        } = this.props;

        return(
            <li className={cn(css.block)}>
                <div className={css.innerBlock}>
                    <div className={css.image}>
                        <img
                            alt={illustrationAltText ? illustrationAltText : ''}
                            src={illustration}
                        />
                    </div>
                    <div className={css.text}>
                        <h2>{heading}</h2>
                        <p>{description}</p>
                        {readMore && (
                            <Button className={css.readmore} href={readMore} secondary>{readMoreText}</Button>
                        )}
                    </div>
                </div>
            </li>
        );
    }
}

export default HMSSlide;



// WEBPACK FOOTER //
// ./src/components/HMSSlide/HMSSlide.jsx